import { Route, Switch } from "react-router-dom";

import Home from "containers/Home";
import Cart from "containers/Cart";
import Layout from "components/Layout";
import Products from "containers/Products";
import DetailProducts from "containers/Products/Detail";

import Account from "containers/Profile";
import Profile from "containers/Profile/Profile";
import Wishlist from "containers/Profile/Wishlist";
import Password from "containers/Profile/Password";
import LayoutProfile from "components/Profile/Layout";
import RentalDetails from "containers/Profile/RentalDetails";

import Checkout from "containers/Checkout";
import RentNow from "containers/Checkout/RentNow";

const App = () => {
  return (
    <>
      <Layout>
        <Switch>
          <Route exact path="/rent-now" component={RentNow} />
          <Route exact path="/checkout" component={Checkout} />
          <Route exact path="/cart" component={Cart} />
          <Route exact path="/products/:slug" component={DetailProducts} />
          <Route exact path="/products" component={Products} />
          <Route exact path="/" component={Home} />
          <LayoutProfile>
            <Route exact path="/account" component={Account} />
            <Route exact path="/account/wishlist" component={Wishlist} />
            <Route exact path="/account/profile" component={Profile} />
            <Route exact path="/account/rental-details" component={RentalDetails} />
            <Route exact path="/account/password" component={Password} />
          </LayoutProfile>
        </Switch>
      </Layout>
    </>
  );
};

export default App;
